<div class="position-relative">
  <button
    class="floating-panel__trigger"
    [ngClass]="'bg-' + (color || 'primary')"
    luiIconButton
    size="xl"
    (click)="togglePopup()"
  >
    <mat-icon
      *ngIf="isPopupVisible; else iconTemplate"
      svgIcon="close_light"
    ></mat-icon>
  </button>

  <div
    *ngIf="isPopupVisible"
    @slide
    class="floating-panel__popup position-absolute p-3 zone-dark"
  >
    <div class="position-relative">
      <ng-content></ng-content>
    </div>
  </div>
</div>

<ng-template #iconTemplate>
  <ng-content select="[buttonIcon]"></ng-content>
</ng-template>
